import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import Card from "../../components/Cards/Card";
import NativeObject from "../../components/NativeObject/NativeObject";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";

import { useSelections } from "../../context/Selections";
import { Footer } from "../../components/Footer/Footer";

function ReportsDesktop({ app, config }) {
  const { selections } = useSelections();

  const [selectedValue, setSelectedValue] = useState("Visitas Planejadas");

  useEffect(() => {
    if (app) {
      // update title with selected distributor (when only 1 is selected)
      const relatorios = selections.length
        ? selections.find((s) => s.qField === "Analise")
        : null;
      setSelectedValue(relatorios?.qSelected);
    }
  }, [app, selections]);

  const handleChange = (event) => {
    console.log("busca: ", event.target.value);
    app.field("Analise").selectMatch(event.target.value, true);
    setSelectedValue(event.target.value);
  };

  return (
    <div className="app reports">
      <div className="appContent">
        <LayoutWrapper>
          <Grid className="container-desempenho">
            <Grid className="container-title-select">
              <Card className="container-card-title">
                <h1 className="title">Scorecard 3PD | Relatórios</h1>
              </Card>
              <FormControl className="container-form-control">
                <InputLabel id="select-relatorios" className="label-select">
                  KPI
                </InputLabel>
                <Select
                  labelId="select-relatorios"
                  className="select"
                  value={selectedValue}
                  onChange={handleChange}
                >
                  <MenuItem value="Visitas Planejadas">
                    Visitas Planejadas
                  </MenuItem>
                  <MenuItem value="Visitas Planejadas x Realizadas">
                    Visitas Planejadas x Realizadas
                  </MenuItem>
                  <MenuItem value="Visitas Realizadas">
                    Visitas Realizadas
                  </MenuItem>
                  <MenuItem value="Visitas x Faturamento">
                    Visitas x Faturamento
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Card
              app={app}
              header={{
                hardTitle: `Detalhamento - ${selectedValue}`,
              }}
              className={"container-detalhamento"}
              exportContainer
              exportTable
              exportTableId="HbgKUF"
              style={{ margin: "16px 0" }}
            >
              {selectedValue === "Visitas Planejadas x Realizadas" && (
                <div className="container-legends">
                  <p className="legends planejadas">
                    <span className="legend-color" />
                    <span className="legend-text">Visitas Planejadas</span>
                  </p>

                  <p className="legends realizadas">
                    <span className="legend-color" />
                    <span className="legend-text">Visitas Realizadas</span>
                  </p>
                </div>
              )}

              <NativeObject
                app={app}
                key="HbgKUF"
                reference={{ id: "HbgKUF" }}
                style={{
                  width: "100%",
                  height: "450px",
                }}
              />
            </Card>
          </Grid>

          <Footer app={app} />
        </LayoutWrapper>
      </div>
    </div>
  );
}

ReportsDesktop.defaultProps = {
  app: null,
  config: {},
};

ReportsDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default ReportsDesktop;
